(function () {
  function initDrawer(drawer) {
    if (!drawer || drawer.dataset.papellMenuReady === "true") return;

    drawer.dataset.papellMenuReady = "true";
    const tabs = Array.from(drawer.querySelectorAll("[data-papell-menu-tab]"));
    const panels = Array.from(drawer.querySelectorAll("[data-papell-menu-panel]"));
    const opener = document.querySelector('[data-hamburger-menu][aria-controls="' + drawer.id + '"]');

    function activateTab(tab, moveFocus) {
      if (!tab) return;

      const panelId = tab.getAttribute("aria-controls");
      tabs.forEach(function (candidate) {
        const isActive = candidate === tab;
        candidate.setAttribute("aria-selected", isActive ? "true" : "false");
        candidate.setAttribute("tabindex", isActive ? "0" : "-1");
        const item = candidate.closest("[data-papell-menu-item]");
        if (item) item.classList.toggle("is-active", isActive);
      });

      panels.forEach(function (panel) {
        const isActive = panel.id === panelId;
        panel.hidden = !isActive;
        panel.classList.toggle("is-active", isActive);
        if (isActive) panel.scrollTop = 0;
      });

      if (moveFocus) tab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        activateTab(tab, false);
      });

      tab.addEventListener("mouseenter", function () {
        if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
          activateTab(tab, false);
        }
      });

      tab.addEventListener("keydown", function (event) {
        let nextIndex = null;
        if (event.key === "ArrowDown") nextIndex = (index + 1) % tabs.length;
        if (event.key === "ArrowUp") nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = tabs.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });

    const observer = new MutationObserver(function () {
      const isOpen = drawer.classList.contains("is-visible");
      if (opener) opener.setAttribute("aria-expanded", isOpen ? "true" : "false");
      if (isOpen) activateTab(drawer.querySelector('[data-papell-menu-tab][aria-selected="true"]') || tabs[0], false);
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }

  function initAllDrawers(root) {
    (root || document).querySelectorAll("[data-papell-menu-drawer]").forEach(initDrawer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAllDrawers(document); });
  } else {
    initAllDrawers(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllDrawers(event.target);
  });
})();
